import React from 'react'
import { Table } from '../../Table'
import type { TableColumnSortOrder } from '../../Table/Table.types'

export const TableExample: React.FC = () => {
  const [linkSortOrder, setLinkSortingOrder] =
    React.useState<TableColumnSortOrder>('asc')
  const [nameSortOrder, setNameSortOrder] =
    React.useState<TableColumnSortOrder>('asc')

  return (
    <Table.Container>
      <Table>
        <Table.Header>
          <Table.HeaderRow>
            <Table.HeaderCell snugfit>
              <Table.Checkbox aria-label="Select All Rows" />
            </Table.HeaderCell>

            <Table.HeaderCell
              sortOrder={linkSortOrder}
              onSortOrderChange={setLinkSortingOrder}
            >
              Link
            </Table.HeaderCell>

            <Table.HeaderCell
              sortOrder={nameSortOrder}
              onSortOrderChange={setNameSortOrder}
              id="header_name"
            >
              Name
            </Table.HeaderCell>

            <Table.HeaderCell>Column Key</Table.HeaderCell>

            <Table.HeaderCell>Percentages</Table.HeaderCell>

            <Table.HeaderCell>Currency</Table.HeaderCell>
          </Table.HeaderRow>
        </Table.Header>

        <Table.Body>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
          <Table.BodyRow>
            <Table.BodyCell>
              <Table.Checkbox aria-label="Select Row" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.LinkCell href="https://procore.github.io/core">
                Link
              </Table.LinkCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.TextAreaCell
                aria-labelledby="header_name"
                defaultValue="Text area!"
                resizable
              />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.InputCell placeholder="Placeholder" />
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.PercentCell>5.00%</Table.PercentCell>
            </Table.BodyCell>

            <Table.BodyCell>
              <Table.CurrencyCell>$21.00</Table.CurrencyCell>
            </Table.BodyCell>
          </Table.BodyRow>
        </Table.Body>
      </Table>
    </Table.Container>
  )
}
